export default __webpack_public_path__ + "static/together-012bcde20b4260f34954c7ad9bdf2b4d.jpeg";